import { Component, Inject } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/pluck';

import { PasswordService } from '../../api/resources/password.service';

@Component({
  selector: 'reset-password',
  styles: [require('./reset-password.less')],
  templateUrl: './reset-password.html',
  providers: [PasswordService],
})
export class ResetPasswordComponent {
  public token$: string;
  public password: string;
  public passwordRepeat: string;
  public matchError: boolean = false;
  public validationError: boolean = false;
  public loading: boolean = false;
  public success: boolean = false;
  public resetError: boolean = false;
  private minPasswordLength: number = 8;

  constructor(
    private route: ActivatedRoute,
    private pwService: PasswordService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token$ = params['token'];
    });
  }

  validate($event) {
    this.validationError = !$event;
  }

  match($event) {
    this.matchError = !$event;
  }

  // Submit password reset
  public resetPassword() {
    this.loading = true;
    return this.pwService.resetPassword(this.password, this.token$)
      .subscribe((res: Response) => {
        this.loading = false;
        this.success = true;
      }, (err: any) => {
        console.log(err);
        this.loading = false;
        this.resetError = true;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/reset-password/reset-password.component.ts